import { html } from 'htm/preact';
import { parsePhoneNumber } from 'libphonenumber-js';
import { useEffect } from 'preact/hooks';

import Header from './Header';
import SectionHeader from './SectionHeader';

const StepFinished = ({ phoneNumber }) => {
  useEffect(() => {
    // Check if Zigpoll is available
    if (window.Zigpoll) {
      window.Zigpoll.pollId = '672e55d2307c0a276fb188bf';
      window.Zigpoll.onload = function () {
        window.Zigpoll.open();
      };
      window.Zigpoll.reload();
    }
  }, []);

  return html`
    <${Header} title="Congrats! All Done!" description="Your new sim is fully activated" />
    ${phoneNumber &&
    html`
      <div class="flex flex-col items-center mb-8">
        <h3 class="flex h4 mb-1.5 normal-case text-center">Your Number</h3>
        <div
          class="flex flex-col mb-6 text-3xl font-bold font-serif capitalize leading-none bg-white rounded-3xl text-purple px-12 py-6"
        >
          ${parsePhoneNumber(`${phoneNumber}`, 'US').format('NATIONAL')}
        </div>
      </div>
    `}
    <div class="flex flex-col items-center max-w-96">
      <${SectionHeader}
        title="What's Next?"
        description="Don't forget to download our mobile app to manage your account with ease."
      />
      <div class="flex gap-3">
        <a href="https://apps.apple.com/app/mingle-mobile/id6505070327" target="_blank">
          <img
            src="https://cdn.shopify.com/s/files/1/0632/5967/2784/files/app-store.png?v=1717428216"
            alt="App Store"
            class="w-36"
          />
        </a>
        <a href="https://play.google.com/store/apps/details?id=com.pixelter.mingle&pli=1" target="_blank">
          <img
            src="https://cdn.shopify.com/s/files/1/0632/5967/2784/files/google-play.png?v=1717428216"
            alt="Google Play"
            class="w-36"
          />
        </a>
      </div>
    </div>
  `;
};

export default StepFinished;
